<template>
    <div>
        <or-page-title>Продукция</or-page-title>
        <div class="layout-1200">
            <div v-if="!selected_category" class="container flex-row row-space-between flex-wrap padding-top-50">
                <div class="loader flex-column flex-center" v-if="categories.length === 0">
                    <img class="loader-img" src="../../assets/logo-loader.svg"/>
                    <p style="color: white; font-size: 14px; margin-top: 50px;">Загружаем данные...</p>
                </div>
                <or-category-card 
                    class="card"
                    v-for="category 
                    in categories" 
                    :key="category.name" 
                    :options="category"
                    @click="select(category)"
                />
            </div>
            <or-products v-else :products="selected_category_products" :scroll_top="scroll_top" :page="'Категории'" :category="selected_category" @close="selected_category = null"/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Axios from 'axios'
import orPageTitle from '../global/or-page-title.vue'
import orCategoryCard from '../global/or-category-card.vue'
import orProducts from '../global/or-products.vue'
export default {
    components: {orPageTitle, orCategoryCard, orProducts},
    data() {
        return {
            selected_category: null,
            products: [
            ],
            categories: [
            ],
            scroll_top: 0,
            products_ready: false,
            production_ready: false,
        }
    },
    computed: {
        ...mapGetters({getProduction: 'getProduction'}),
        selected_category_products() {
            return this.products.filter(el=>el.production_category_id === this.selected_category.id)
        }
    },
    mounted() {
        if (this.getProduction === null) {
            this.changeIsPageReady({is: false});
        }
        const i = setInterval(()=>{
            if (this.getProduction !== null) {
                clearInterval(i);
                this.getFromState()
            }
        }, 10);
    },
    methods: {
        ...mapActions({changeIsPageReady: 'changeIsPageReady', changeProduction: 'changeProduction'}),
        getFromState() {
            this.products = this.getProduction.products;
            this.categories = this.getProduction.categories;
            this.changeIsPageReady({is: true});
        },
        select(category) {
            this.selected_category = category;
            this.scroll_top = window.scrollY;
        }
    }
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .loader {
        position: fixed;
        top: 320px;
        left: 0;
        width: 100vw;
        /* max-width: 100%; */
        height: calc(100vh - 320px);
        z-index: 999999;
        background-color: black;
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(1080deg);}
    }
    .loader-img {
        animation-name: loader;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }
</style>